/**
 * @desc 根据FNSKU获取对应的sku
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.MskuRequestRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/msku/getByFnsku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
